"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const styled_components_1 = __importDefault(require("styled-components"));
const FeedbackCopy_1 = __importDefault(require("../../common/FeedbackCopy"));
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "padding-bottom",
    values: { sm: "0px", md: "24px", lg: "0px" },
})};

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "flex-grow",
    values: { md: "1" },
})};
`;
const TextFieldWrapper = styled_components_1.default.div `
  margin-top: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    margin-bottom: 10px;
  }
`;
const StyledTextField = (0, styled_components_1.default)(common_buoy_input_1.TextArea) `
  width: 100%;
`;
const Paragraph = styled_components_1.default.p `
  ${({ theme }) => theme.typography.variants.primary.small};
  margin: 0 0 32px;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "max-width",
    values: { lg: "581px" },
})};
`;
const StyledLink = (0, styled_components_1.default)(common_buoy_button_1.Link) `
  ${({ theme }) => theme.typography.variants.primary.small};
`;
const TextFeedback = ({ handleValueChange, disableAutoFocus, }) => ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsxs)(TextFieldWrapper, { children: [(0, jsx_runtime_1.jsxs)(Paragraph, { children: [FeedbackCopy_1.default.Legal, " ", (0, jsx_runtime_1.jsx)(StyledLink, { href: "/privacy", target: "_blank", children: FeedbackCopy_1.default.Privacy }), "."] }), (0, jsx_runtime_1.jsx)(StyledTextField, { autoFocus: !disableAutoFocus, "data-testid": "text-field", helperText: FeedbackCopy_1.default.Optional, onChange: (e) => handleValueChange(e.target.value), placeholder: FeedbackCopy_1.default.FreeTextPlaceholder })] }) }));
exports.default = TextFeedback;
//# sourceMappingURL=index.js.map